import {
  FAILED_GET_VESSEL,
  FAILED_GET_VESSELS,
  FAILED_PERSIST_VESSEL,
  RECEIVE_GET_VESSEL,
  RECEIVE_GET_VESSELS,
  RECEIVE_PERSIST_VESSEL,
  REQUEST_PERSIST_VESSEL,
} from 'redux/actions/vessel'
import { RESET_STATE } from 'redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false,
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_VESSEL:
    case FAILED_PERSIST_VESSEL:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        },
      }
    case FAILED_GET_VESSELS:
      return {
        ...state,
        overview: {
          ...state.overview,
          fetching: false,
          error: action.error,
        },
      }
    case RECEIVE_PERSIST_VESSEL:
    case RECEIVE_GET_VESSEL:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        },
      }
    case RECEIVE_GET_VESSELS:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        },
      }
    case REQUEST_PERSIST_VESSEL:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true,
        },
      }
    case RESET_STATE:
      if (action.state === 'vessel') {
        return {
          ...state,
          [action.screen]: initialState[action.screen],
        }
      }

      return state
    default:
      return state
  }
}
